import { createSelector } from 'reselect';
import { lowerCase, toLower } from 'lodash/fp';

import { AgeBracket } from '../select-age-bracket';
import constants from '../../ahm-constants';
import getIncomeTierOptions from '../../utils/get-income-tier-options';
import selectAgeBracket from '../select-age-bracket-option';
import selectCustomer from '../select-customer';
import selectCustomerAges, { MemberYouthDiscountAgesType } from '../select-youth-discount-ages';

// @ts-expect-error - Automatic, Please fix when editing this file
const getIncomeTier = (customer) => getIncomeTierOptions({ incomeType: customer.incomeType })?.[customer.incomeTier];

const selectCustomerHumanReadable = createSelector(
  [selectAgeBracket, selectCustomer, selectCustomerAges],
  (ageBracket, customer, ages) => ({
    ageBracket,
    ages,
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object is possibly 'undefined'.
    incomeTier: getIncomeTier(customer).text,
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ single: string; couple: string; }'.
    incomeType: toLower(constants.INCOME_TYPE_LABEL[customer.incomeType]),
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type '"single" | "couple" | "family" | "single-parent" | "family-plus-21" | "single-parent-plus-21"' can't be used to index type '{ single: string; couple: string; family: string; "single-parent": string; }'.
    scale: lowerCase(constants.SCALE_LABEL[customer.scale]),
    state: constants.STATE_LABEL[customer.state],
  }),
);

export default selectCustomerHumanReadable;

export type CustomerHumanReadablePropTypes = {
  ageBracket: AgeBracket;
  ages: MemberYouthDiscountAgesType;
  incomeTier: string;
  incomeType: string;
  scale: string;
  state: string;
};
